(function() {
    angular
      .module('meanApp')
      .controller('intermediateSearchCtrl', intermediateSearchCtrl);
  
      intermediateSearchCtrl.$inject = [
            '$scope', 
            '$location', 
            'authentication', 
            'loginModal', 
            'searchModal', 
            'context', 
            '$state',
            'searchData'];
        function intermediateSearchCtrl(
            $scope, 
            $location, 
            authentication, 
            loginModal, 
            searchModal, 
            context, 
            $state,
            searchData) {
            
            var vm = this;
            if(searchData.getTextSearch()) {
                vm.searchQueryPrefilled = true;
                vm.searchQuery = searchData.getTextSearch();
            }

            vm.goToSearchStepOne = function() {
                searchModal.modalInstance.close();
                $state.go('recipeSearchStep', {
                    step: '1'
                });
            };

            vm.goToSearchResultByText = function () {
                searchModal.modalInstance.close();
                $state.go('recipeTextSearchResult', {
                    search: vm.searchQuery
                });
            };
        }
  })();